import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { routesPublic } from "@/router/routes/RoutesPublic";
import { routesPrivate } from "@/router/routes/RoutesPrivate";
import { getCurrentUser } from "@/api/user";
import { useUserStore } from "@/store/user";
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: "/search",
  },
  ...routesPublic,
  ...routesPrivate,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { requireAuth, roles } = to.meta;
  if (requireAuth) {
    try {
      const user = useUserStore()
      let permissions =  user.user.permissions
      if(!user.token){
        const response = await getCurrentUser();
        permissions = response.permissions
      }

      //eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      if (!roles.some((p) => permissions.includes(p))) {
        return next({
          path: "/login",
          query: { redirect: to.fullPath }
        });
      }
    } catch (error) {
      console.error("User not authenticated", error);
      return next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  }
  next();
});


export default router;
